
  var _styles = {
  "trip-guide": {
    "display": "flex",
    "flexDirection": "column",
    "width": "10rem"
  },
  "trip-guide__header": {
    "display": "flex",
    "flexDirection": "column",
    "paddingTop": 0,
    "paddingRight": "0.32rem",
    "paddingBottom": 0,
    "paddingLeft": "0.32rem"
  },
  "trip-guide__title": {
    "fontSize": "0.42667rem",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "color": "rgb(17,17,17)",
    "marginTop": "0.32rem"
  },
  "trip-guide__cards": {
    "display": "flex",
    "flexDirection": "column",
    "position": "relative"
  },
  "trip-guide__scroll": {
    "display": "flex",
    "flexDirection": "row",
    "width": "10rem",
    "position": "relative",
    "zIndex": 1
  },
  "trip-guide__cards-list": {
    "display": "flex",
    "flexDirection": "row",
    "paddingLeft": "0.32rem",
    "paddingBottom": "0.02667rem"
  },
  "trip-guide__loading": {
    "display": "flex",
    "flexDirection": "column",
    "fontSize": "0.37333rem",
    "lineHeight": "0.66667rem",
    "color": "rgb(153,153,153)",
    "textAlign": "center",
    "paddingTop": "1.06667rem",
    "paddingBottom": "1.06667rem"
  },
  "trip-guide__error": {
    "display": "flex",
    "flexDirection": "column",
    "fontSize": "0.37333rem",
    "lineHeight": "0.66667rem",
    "color": "rgb(255,80,0)",
    "textAlign": "center",
    "paddingTop": "1.06667rem",
    "paddingBottom": "1.06667rem"
  }
};



  module.exports = _styles;
  